<!-- eslint-disable -->
<template lang="pug">
    .play-box(v-if='!isOlympiad || (isOlympiad && !gameEnd)')
        .play-box__sound-loader(v-if='isSingleScreen && !isSoundsLoaded')
            progress(:value='this.loadedSound/this.soundObjects.length * 100', max='100')
                | {{ this.loadedSound / this.soundObjects.length * 100 }}%
            | {{ $i18n.t('trainer.trainer_gamePlayBox_gameLoading') }}
        template(v-else='')
            template(v-if='isStarted')
                game-header(
                    @soundStateChanged="headerKey = !headerKey",
                    :key="headerKey",
                    :slug='type',
                    :game-type='parameters && parameters.courseType',
                    :is-homework="!!exerciseId",
                )
                .play-box__game(v-if='!gameEnd')
                    .play-box__example
                        .play-box__abacus
                            abacus(
                                v-if="currentNumber !== null"
                                :number="currentNumber"
                                :is-static="true"
                            )
                    game-info.play-box__game-info(
                        :time="getTime"
                        :is-olympiad="isOlympiad"
                    )
                .play-box__reaction-container(v-else='')
                    result-image.play-box__image(status="success")
                    result-buttons(
                        v-if="isSingleScreen"
                        :exercise-id="exerciseId"
                        games-type="mentalArithmetic"
                        show-restart-button
                        @restartGame="restartGame"
                    )
                        slot
            game-preparation-counter(v-else-if="number < 4", :counter="number")
</template>

<script>
    /*eslint-disable*/
    import GameStatsApi from '../../../../api/games/gameStat';

    import trainerConfig from '../../../../config/trainer';

    import GameMixin from '../../../../utils/trainer/game';
    import FlashCardsMixin from '../../../../utils/trainer/FlashCardsMixin';
    import timer from '../../../../utils/trainer/timer';
    import EndGameMixin from '../../../../utils/trainer/endGame'

    import GameHeader from '../../GameHeader.vue';
    import Abacus from '../../../tools/abacus/Abacus.vue';
    import GamePreparationCounter from '../../GamePreparationCounter.vue'

    import GameInfo from '../GameInfo.vue'
    import ResultImage from "../ResultImage.vue";
    import ResultButtons from '../ResultButtons.vue'

    function DEFAULT_DATA () {
        return {
            number: null,
            isStarted: false,
            parameters: null,
            showTurtle: true,
            isActive: false,
            gameEnd: false,
            stopGame: false,
            showProblem: false,
            getLastNumbers: false,
            loadedSound: 0,
            countdownInstance: null,
            bgMusicInstance: null,
            resultInstance: null,
            isLoaded: false,
            min: null,
            max: null,
            currentNumber: null,
            generating: null,
            isSoundsLoaded: false,
            headerKey: false,
        }
    }

    export default {
        data () {
            return DEFAULT_DATA();
        } ,
        mixins: [GameMixin, FlashCardsMixin, timer, EndGameMixin],
        props: ['exerciseId', 'type', 'place', 'gameType', 'playersNumber', 'checkMultiplayerAnswers', 'playAgain'],
        components: {
            ResultImage,
            ResultButtons,
            GameInfo,
            GamePreparationCounter,
            Abacus,
            GameHeader
        },
        mounted() {
            this.fetchData()
            .then(() => {
                if (!this.isSingleScreen) {
                    this.number = 3;
                } else {
                    this.$createjs.Sound.removeAllSounds();
                    this.$createjs.Sound.removeAllEventListeners();
                    this.$createjs.Sound.addEventListener('fileload', this.soundLoad);
                    this.$createjs.Sound.alternateExtensions = ["mp3"];
                    this.$createjs.Sound.registerSounds(this.soundObjects);
                }
            })
        },
        beforeDestroy () {
            clearTimeout(this.generating);
            this.$createjs.Sound.removeAllSounds();
            this.$createjs.Sound.removeAllEventListeners();
        },
        watch: {
            gameEnd (val) {
                this.$emit('playAgainReady', val);
            },
            'time'(val) {
                if (val >= this.parameters.duration*60) {
                    clearTimeout(this.timer);
                    this.gameEnd = true;
                    clearTimeout(this.generating);
                    if (!this.$offline && this.exerciseId) {
                        this.sendStat();
                    }
                }
            },
            number(val) {
                if (val > 0) {
                    this.preparation();
                } else {
                    this.setTimer();
                    clearTimeout(this.generating);
                    this.defineMinAndMax();
                    this.generateNumber();
                    this.isStarted = true;
                }
            },
            playAgain (val) {
                if (val && this.gameEnd) {
                    this.restartGame();
                }
            }
        },
        methods: {
            soundLoad() {
                this.loadedSound++;
                if (this.loadedSound === this.soundObjects.length) {
                    this.isSoundsLoaded = true;
                    this.number = 3;
                }
            },
            generateNumber() {
                let previousNumber = this.currentNumber;
                while (this.currentNumber === previousNumber) {
                    this.currentNumber = Math.round(this.min - 0.5 + Math.random() * (this.max - this.min + 1));
                    if (this.parameters.difficult.thousands) {
                        this.currentNumber = Math.floor(this.currentNumber / 1000) * 1000;
                    } else if (this.parameters.difficult.hundreds) {
                        this.currentNumber = Math.floor(this.currentNumber / 100) * 100;
                    } else if (this.parameters.difficult.tens) {
                        this.currentNumber = Math.floor(this.currentNumber / 10) * 10;
                    }
                }
                this.generating = setTimeout(this.generateNumber, this.parameters.speed*1000);
            },
            preparation() {
                if (this.isSingleScreen) {
                    this.countdownInstance = this.$createjs.Sound.play("beep");
                    this.countdownInstance.volume = 0.6;
                }
                setTimeout(() => {
                    this.number--;
                }, 1000);
            },
            restartGame() {
                this.time = 0;
                this.number = 3;
                this.isStarted = false;
                this.gameEnd = false;
            }
        },
        computed: {
            isOlympiad () {
                return this.gameType === 'olympiad'
            },
            isSingleScreen () {
                return !this.playersNumber || this.playersNumber === 1;
            },
            soundObjects () {
                if (!this.isSingleScreen) {
                    return;
                }
                return [...trainerConfig.countdownSound];
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "@/assets/sass/games/playbox.scss";

    .play-box__reaction-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .play-box__image {
        max-width: 100%;
        margin-bottom: 30px;
        @include media($md) {
            margin-bottom: 40px;
        }
    }

    .play-box__buttons {
        display: flex;
        flex-direction: column;
        @include media($lg) {
            flex-direction: row;
        }
    }

    .play-box__button {
        margin: 20px 0;
        @include media($lg) {
            margin: 0 20px;
        }
    }

    .play-box__button:first-child {
        margin-top: 0;
        @include media($lg) {
            margin-left: 0;
        }
    }

    .play-box__button:last-child {
        margin-bottom: 0;
        @include media($lg) {
            margin-right: 0;
        }
    }

    .play-box__game {
        display: flex;
        flex: 1 1 auto;
        flex-direction: column-reverse;
        @include media($md) {
            flex-direction: row;
        }
    }

    .play-box__game-info {
        align-self: flex-end;
        @include media($md) {
            align-self: auto;
        }
    }

    .play-box__example {
        height: 100%;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        flex-grow: 5;
    }

    .play-box__abacus {
        flex-grow: 5;
        display: flex;
        justify-content: center;
    }

</style>
